import React, { useEffect } from 'react'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ISearchResult } from 'submodules/nerit-framework-utils/sdk-utils/dtos/interfaces/ISearchResult'
import { MatrixRequests } from 'submodules/nerit-aquatec-sdk/services/matrix/MatrixRequests'
import { MatrixResponseDTO } from 'submodules/nerit-aquatec-sdk/services/matrix/dtos/responses/MatrixResponseDTO'

interface ICPProps {
    isRequired?: boolean
    onChange?: (matrixCode?: number) => void
    fieldName?: string
    formStateManager?: IFormStateManager<any>
    width?: number
}

/**
 * Select de Matriz. Na consulta de dados a Matriz funciona como a Campanha:
 * ao escolher uma matriz o consumidor deve prefixar o filtro de pontos.
 */
export function SelectMatrixCP(props: ICPProps): JSX.Element {

    const searchRequest = useRequest<ISearchResult<MatrixResponseDTO>>()
    useEffect(onSearchRequestChange, [searchRequest.isAwaiting])

    useEffect(init, [])

    function init(): void {
        searchRequest.runRequest(MatrixRequests.search({ itemsPerPage: 999, page: 1 }))
    }

    function onSearchRequestChange(): void {
        RequestUtils.isValidRequestReturn(searchRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)
    }

    const matrices = searchRequest.responseData?.list ?? []

    return (
        <SelectCP
            label={'Matriz'}
            required={!!props.isRequired}
            loading={searchRequest.isAwaiting}
            allowClear={true}
            options={matrices.map((matrix) => ({
                value: matrix.code,
                label: `${matrix.name} (${matrix.totalLocations})`,
            }))}
            onChange={props.onChange}
            width={props.width}
            formStateManager={props.formStateManager}
            fieldName={props.fieldName}
        />
    )
}
